/**
 * Converts a Draft JS selection into a range object.
 */
export default (selection) => ({
    startKey: selection.getStartKey(),
    startOffset: selection.getStartOffset(),
    endKey: selection.getEndKey(),
    endOffset: selection.getEndOffset(),
});
